let pi = 3.14159267;

export default class Animation {
    constructor(element, definition, queueStep) {
        if (typeof queueStep != 'function')
            throw new Error("Animation constructor parameter queueStep is not a function!")

        this.element = element;
        this.queueStep = queueStep;

        this.targetAttr = definition.targetAttr;
        this.startAttr = definition.startAttr;
        this.duration = definition.duration;
        this.callback = definition.callback;
        this.selector = definition.selector;

        this.startTime = null;
        this.running = true;
    }

    setCallback(callback) {
        if (typeof callback != 'function')
            throw new Error("Supplied callback is not a function")

        this.callback = callback;
    }

    start() {
        this.queueStep((timestamp) => { this.step(timestamp) })
    }

    setAttributes(phase) {
        // Set individual attributes
        for (let key in this.targetAttr) {
            let start = this.startAttr[key],
                target = this.targetAttr[key];

            let tweenOffset = (target.value - start.value) * phase,
                currentValue = tweenOffset + start.value;

            this.element.style[key] = `${currentValue}${target.units}`;
        }
    }

    getPhase(timestamp) {
        return (timestamp - this.startTime) / this.duration;
    }

    getEase(phase) {
        return (Math.sin(pi * (phase - .5)) + 1) / 2
    }

    step(timestamp) {
        if (!this.startTime) { 
            this.startTime = timestamp;
        }

        let phase = this.getPhase(timestamp);
        let easedPhase = this.getEase(phase);
        this.setAttributes(easedPhase);

        // Request animation frame using this function, and bail
        if (phase < 1 && this.running) {
            this.queueStep((timestamp) => { this.step(timestamp) });
            return;
        }

        // We're done! Call the callback.
        this.callback({ 
            selector: this.selector, 
            targetAttr: this.targetAttr 
        });
    }
}



// WEBPACK FOOTER //
// ./src/Animation.js


// WEBPACK FOOTER //
// webpack:///src/Animation.js